import { Box, Grid, IconButton, Typography } from "@mui/material"
import InputSecondNewDatePicker from "component/Input/InputSecondNewDatePicker"
import { icons } from "constants/images"
import { colors } from "constants/theme"
import _, { floor } from "lodash"
import moment from "moment"
import DateInput from "new-components/inputs/date-input"
import SelectInput from "new-components/inputs/select-input"
import TextInput from "new-components/inputs/text-input"
import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { DateObject } from "react-multi-date-picker"
import { numberFormat } from "utils/app.utils"

export interface PaymentInstallmentListProps {
    installmentId: number | null
    paidDate: string
    optionPrice: PERCENT_OP
    price: number
    installmentNumber: number
    status: PaymentInstallmentListStatus
}

export enum PaymentInstallmentListStatus {
    PENDING = 'PENDING',
    PAID = 'PAID',
    DELETE = 'DELETE'
}

export interface PaymentInstallmentBoxProps {
    operativeTotal: number
    paymentInstallmentList: PaymentInstallmentListProps[]
    setPaymentInstallmentList: React.Dispatch<React.SetStateAction<PaymentInstallmentListProps[]>>
    autoScroll?: () => void
    disabled?: boolean
}

export enum PERCENT_OP {
    AVERAGE = "AVERAGE",
    CUSTOM = "CUSTOM",
    PER10 = "PER10",
    PER20 = "PER20",
    PER30 = "PER30",
    PER40 = "PER40",
    PER50 = "PER50",
    PER60 = "PER60",
    PER70 = "PER70",
    PER80 = "PER80",
    PER90 = "PER90",
}

const PaymentInstallmentBox = (props: PaymentInstallmentBoxProps) => {
    const { t } = useTranslation()
    const { operativeTotal, paymentInstallmentList, setPaymentInstallmentList, autoScroll } = props

    const [isPay, setIsPay] = useState<number[]>([])
    const [isEdit, setIsEdit] = useState<boolean>(false)

    const percentOption = [
        { name: t('TREATMENT_COURSE.FORM.PAYMENT.PAYMENT_METHOD_AVERAGE'), value: PERCENT_OP.AVERAGE },
        { name: t('TREATMENT_COURSE.FORM.PAYMENT.PAYMENT_METHOD_CUSTOM'), value: PERCENT_OP.CUSTOM },
        { name: t('10%'), value: PERCENT_OP.PER10 },
        { name: t('20%'), value: PERCENT_OP.PER20 },
        { name: t('30%'), value: PERCENT_OP.PER30 },
        { name: t('40%'), value: PERCENT_OP.PER40 },
        { name: t('50%'), value: PERCENT_OP.PER50 },
        { name: t('60%'), value: PERCENT_OP.PER60 },
        { name: t('70%'), value: PERCENT_OP.PER70 },
        { name: t('80%'), value: PERCENT_OP.PER80 },
        { name: t('90%'), value: PERCENT_OP.PER90 },
    ]

    const calPercent = (optionPrice: string) => {
        const perNum = optionPrice.split('PER')[1]
        return Number(perNum || 0) / 100
    }

    const checkEndsWithDot = (text: any) => {
        if (text[text.length - 1] === ".") return Number(text.replace(".", ""))
        else return Number(text)
    };

    const calAmountPaymentInstallmentList = (prev: PaymentInstallmentListProps[], status?: string, index?: number, type?: string) => {
        let payLater = 0
        let payLaterAver = 0
        let payPer = 0
        const sumInstallment = { paid: 0, custom: 0, average: 0, per: 0 }

        const newPrev = prev.filter((item, i) => {
            if (item.status !== PaymentInstallmentListStatus.PAID) {
                return item
            } else {
                if (item.optionPrice === PERCENT_OP.AVERAGE) {
                    payLaterAver += checkEndsWithDot(item.price)
                } else if (item.optionPrice !== PERCENT_OP.CUSTOM) {
                    payPer += checkEndsWithDot(item.price)
                }
                payLater += checkEndsWithDot(item.price)
            }
        })

        let totalCustom = 0
        const totalPercent = prev.reduce((total, item, i) => {
            if (((index && Number(i) !== index) || true) && item.optionPrice.includes("PER")) {
                return total += Number(item.optionPrice.split('PER')[1] || 0)
            }
            return total
        }, 0)

        prev.forEach((item) => {
            if (item.optionPrice === PERCENT_OP.CUSTOM) {
                totalCustom += checkEndsWithDot(item.price)
                sumInstallment.custom += checkEndsWithDot(item.price)
            }
        })


        // - payLater
        const opTotal = operativeTotal
        const newTotalCustom = opTotal - totalCustom
        const newTotalPer = newTotalCustom * (totalPercent / 100)
        let totalAll = index ? _.sumBy(_.filter(paymentInstallmentList, (pos, i) => Number(i) !== Number(index)), 'price') : _.sumBy(paymentInstallmentList, 'price') > opTotal ? 0 : newTotalCustom - newTotalPer - payLaterAver
        const countAdd = status === "NEW" ? 1 : 0
        const countAverage = newPrev.filter((item) => item.optionPrice === PERCENT_OP.AVERAGE)?.length + countAdd
        const amountAerage = totalAll / countAverage

        let newTotal = 0
        let currentAverage = 0
        let newTotalAverage = 0
        let dataPrev = prev.map((info: any) => {
            if (info.status === PaymentInstallmentListStatus.PAID) {
                newTotal += checkEndsWithDot(info.price)
                sumInstallment.paid += Number(newTotal)

                return info
            }
            if (info.optionPrice === PERCENT_OP.AVERAGE) {
                currentAverage += 1
                totalAll = newTotalCustom - sumInstallment.paid - sumInstallment.per
                totalAll = totalAll < 0 ? 0 : totalAll


                const newAmount = Number((Math.ceil((totalAll / countAverage) * 100) / 100).toFixed(2))
                newTotalAverage += Math.ceil((totalAll / countAverage) * 100) / 100
                newTotal += Number(newAmount.toFixed(2))
                sumInstallment.average += Number(newAmount)
                return { ...info, price: Number(newAmount) }
            } else if (info.optionPrice.includes('PER')) {
                const newAmount = _.find(prev, (item: any) => item.optionPrice === 'CUSTOM') ? opTotal * calPercent(info.optionPrice) : newTotalCustom * calPercent(info.optionPrice)
                newTotal += Number(newAmount)

                sumInstallment.per += Number(newAmount)
                return { ...info, price: Number(newAmount) }
            }
            newTotal += checkEndsWithDot(info.price)
            return info
        })


        if (newTotal > opTotal) {
            newTotal = newTotal - sumInstallment.average
            newTotalAverage = 0
            totalAll = newTotalCustom - sumInstallment.paid - sumInstallment.per
            totalAll = totalAll > 0 ? totalAll : 0
            sumInstallment.average = 0
            dataPrev = dataPrev.map((info: any) => {
                if (info.status === PaymentInstallmentListStatus.PAID) {
                    return info
                }
                if (info.optionPrice === PERCENT_OP.AVERAGE) {
                    currentAverage += 1
                    const newAmount = totalAll > 0 ? Math.ceil((totalAll / countAverage) * 100) / 100 : 0
                    newTotalAverage += totalAll > 0 ? Math.ceil((totalAll / countAverage) * 100) / 100 : 0
                    newTotal += Number(newAmount.toFixed(2))
                    sumInstallment.average += Number(newAmount.toFixed(2))
                    return { ...info, price: Number(newAmount.toFixed(2)) }
                }
                return info
            })

        }


        return { dataPrev, newTotal }
    }

    const handleAddPaymentInstallmentList = () => {
        setPaymentInstallmentList((prev) => {
            const { dataPrev, newTotal } = calAmountPaymentInstallmentList(prev, 'NEW')
            const newData = {
                paidDate: '',
                optionPrice: PERCENT_OP.AVERAGE,
                price: Number((operativeTotal - newTotal <= 0 ? 0 : operativeTotal - newTotal).toFixed(2)),
                installmentNumber: paymentInstallmentList.length + 1,
                installmentId: null,
                status: PaymentInstallmentListStatus.PENDING
            }
            autoScroll && autoScroll()
            return [...dataPrev, newData]
        })
    }

    const handleFloatNumber = (input: number) => {
        if (input?.toString()?.length && input?.toString()[input?.toString()?.length - 1] === '.') {
            const newInput: number = input
            return newInput
        } else {
            return Number(input)
        }
    }

    const handleChangePaymentInstallmentList = (index: number, type: string, value: any) => {
        setPaymentInstallmentList((prev) => {
            const newPrev = { ...prev[index] }
            if (type === 'optionPrice') {
                if (![PERCENT_OP.AVERAGE, PERCENT_OP.CUSTOM].includes(value)) {
                    const totalMax = operativeTotal - prev.reduce((total, item, i) => {
                        if (item.optionPrice === PERCENT_OP.CUSTOM && i !== index || item.status === PaymentInstallmentListStatus.PAID) {
                            return total + checkEndsWithDot(item.price)
                        }
                        return total
                    }, 0)

                    newPrev.price = Number((totalMax * calPercent(value)).toFixed(2))
                }
                newPrev[type] = value
                prev[index] = newPrev
                const { dataPrev, newTotal } = calAmountPaymentInstallmentList(prev, undefined, index, type)
                if (dataPrev.length > 0) {
                    const checkBalance = operativeTotal - newTotal === 0 ? 0 : Number((operativeTotal - newTotal).toFixed(2));
                    const indexUpdate = _.findLastIndex(dataPrev, (item: any) => {
                        return item.optionPrice === PERCENT_OP.AVERAGE && item.status !== PaymentInstallmentListStatus.PAID
                    })
                    if (indexUpdate !== -1) {
                        if (checkBalance < 0 && dataPrev[indexUpdate].price === 0) dataPrev[indexUpdate].price = 0
                        else dataPrev[indexUpdate].price = Number((checkBalance + dataPrev[indexUpdate].price).toFixed(2))
                    }
                }
                return dataPrev

            } else if (type === 'price') {
                const totalMax = operativeTotal - prev.reduce((total, item, i) => {
                    if (item.optionPrice === PERCENT_OP.CUSTOM && i !== index || item.status === PaymentInstallmentListStatus.PAID) {
                        return total + checkEndsWithDot(item.price)
                    }
                    return total
                }, 0)
                newPrev.optionPrice = PERCENT_OP.CUSTOM
                let newValue = value
                const pattern = /^[0-9.]+$/;
                if (pattern.test(newValue) && !isNaN(newValue)) {
                    const inputValue = newValue
                    newValue = handleFloatNumber(inputValue)
                }
                newPrev[type] = totalMax < checkEndsWithDot(value) ? totalMax : newValue
                prev[index] = newPrev

                const { dataPrev, newTotal } = calAmountPaymentInstallmentList(prev)
                if (dataPrev.length > 0) {
                    const checkBalance = operativeTotal - newTotal === 0 ? 0 : Number((operativeTotal - newTotal).toFixed(2));
                    const indexUpdate = _.findLastIndex(dataPrev, (item: any) => {
                        return item.optionPrice === PERCENT_OP.AVERAGE && item.status !== PaymentInstallmentListStatus.PAID
                    })

                    if (indexUpdate !== -1) {
                        if (checkBalance < 0 && dataPrev[indexUpdate].price === 0) dataPrev[indexUpdate].price = 0
                        else dataPrev[indexUpdate].price = Number((checkBalance + dataPrev[indexUpdate].price).toFixed(2))
                    }
                }
                return dataPrev
            }

            prev[index] = { ...prev[index], [type]: value }
            autoScroll && autoScroll()
            return [...prev]
        })
    }

    const handleDeletePaymentInstallmentList = (index: number) => {
        setPaymentInstallmentList((prev) => {
            const newData = prev.filter((_, num) => num !== index)
            const { dataPrev, newTotal } = calAmountPaymentInstallmentList(newData)
            if (dataPrev.length > 0) {
                const checkBalance = operativeTotal - newTotal === 0 ? 0 : Number((operativeTotal - newTotal).toFixed(2));
                const indexUpdate = _.findLastIndex(dataPrev, (item: any) => {
                    return item.optionPrice === PERCENT_OP.AVERAGE && item.status !== PaymentInstallmentListStatus.PAID
                })
                if (indexUpdate !== -1) {
                    if (checkBalance < 0 && dataPrev[indexUpdate].price === 0) dataPrev[indexUpdate].price = 0
                    else dataPrev[indexUpdate].price = Number((checkBalance + dataPrev[indexUpdate].price).toFixed(2))
                }
            }
            return dataPrev
        })
    }

    const handleChangePaymentInstallmentListAverage = () => {
        setPaymentInstallmentList((prev) => {
            const newData = prev.map((item) => {
                if (item.status === PaymentInstallmentListStatus.PAID) {
                    return item
                }
                return ({ ...item, optionPrice: PERCENT_OP.AVERAGE })
            })
            const { dataPrev, newTotal } = calAmountPaymentInstallmentList(newData)
            autoScroll && autoScroll()
            if (dataPrev.length > 0) {
                const checkBalance = operativeTotal - newTotal === 0 ? 0 : Number((operativeTotal - newTotal).toFixed(2));
                const indexUpdate = _.findLastIndex(dataPrev, (item: any) => {
                    return item.optionPrice === PERCENT_OP.AVERAGE && item.status !== PaymentInstallmentListStatus.PAID
                })
                if (indexUpdate !== -1) {
                    if (checkBalance < 0 && dataPrev[indexUpdate].price === 0) dataPrev[indexUpdate].price = 0
                    else dataPrev[indexUpdate].price = Number((checkBalance + dataPrev[indexUpdate].price).toFixed(2))
                }
            }
            return dataPrev
        })
    }

    const renderDateMaxMin = useCallback((index: number) => {
        if (index || index === 0) {
            const newDate = paymentInstallmentList[index]?.paidDate
            if (newDate) {
                return new DateObject(newDate)
            } else {
                return ''
            }
        } else {
            return ''
        }

    }, [paymentInstallmentList])

    const renderPaymentInstallmentListTotal = useCallback(() => {
        const updatedList = paymentInstallmentList.map(item => ({
            ...item,
            price: isNaN(item.price) ? 0 : checkEndsWithDot(item.price)
        }));
        const newPayment = updatedList.reduce((total, item) => total + checkEndsWithDot(item.price), 0)
        return newPayment
    }, [paymentInstallmentList])

    const renderPercentOption = useCallback((optionPrice: string) => {
        let percentCurrent = 0
        if (optionPrice.includes("PER")) {
            percentCurrent = Number(optionPrice.split('PER')[1] || 0)
        }

        const newPercent = ((100) + percentCurrent) - paymentInstallmentList.reduce((total, item) => {
            if (item.optionPrice.includes("PER")) {
                return total += Number(item.optionPrice.split('PER')[1] || 0)
            }
            return total
        }, 0)
        const newOp = percentOption.map((item: { name: string, value: string }) => {
            if (item.value.includes("PER")) {
                return { ...item, disabled: (newPercent < Number(item.value.split('PER')[1] || 0)) }
            } else {
                return item
            }
        })
        return newOp.filter((item) => {
            if ((isEdit && (item.value === PERCENT_OP.AVERAGE || item.value === PERCENT_OP.CUSTOM)) || !isEdit) {
                return item
            }
        })
    }, [paymentInstallmentList, isEdit])

    useEffect(() => {
        setPaymentInstallmentList((prev) => {
            const { dataPrev, newTotal } = calAmountPaymentInstallmentList(prev)
            if (dataPrev.length > 0) {
                const checkBalance = operativeTotal - newTotal === 0 ? 0 : Number((operativeTotal - newTotal).toFixed(2));
                const indexUpdate = _.findLastIndex(dataPrev, (item: any) => {
                    return item.optionPrice === PERCENT_OP.AVERAGE && item.status !== PaymentInstallmentListStatus.PAID
                })
                if (indexUpdate !== -1) {
                    if (checkBalance < 0 && dataPrev[indexUpdate].price === 0) dataPrev[indexUpdate].price = 0
                    else dataPrev[indexUpdate].price = Number((checkBalance + dataPrev[indexUpdate].price).toFixed(2))
                }
            }
            return dataPrev
        })
    }, [operativeTotal])

    useEffect(() => {
        if (paymentInstallmentList?.length && paymentInstallmentList.some((item) => item.status === PaymentInstallmentListStatus.PAID)) {
            setIsEdit(true)
            paymentInstallmentList.forEach((item, index) => {
                if (item.status === PaymentInstallmentListStatus.PAID) {
                    setIsPay((prev) => [...prev, item.installmentNumber])
                }
            })
        }
    }, [])

    return (
        <Box>
            {(!props.disabled && window.location.pathname !== '/approvel-list/change-cost') &&
                <Box
                    display='flex'
                    alignItems='center'
                    gap='8px'
                    height='24px'
                    width='fit-content'
                    sx={{ cursor: 'pointer', filter: !(paymentInstallmentList?.length < 10) ? 'grayscale(1)' : '' }}
                    onClick={() => paymentInstallmentList?.length < 10 && handleAddPaymentInstallmentList()}
                >
                    <Box color={colors.themeSecondColor} fontWeight={500} fontSize={25}>
                        +
                    </Box>
                    <Typography className="mt-2" sx={{ fontWeight: 500, color: colors.themeSecondColor }}>
                        {t('TREATMENT_COURSE.FORM.PAYMENT.LNSTALLMENT_ADD')}
                    </Typography>
                </Box>
            }
            <Box display='flex' flexDirection='column' gap='16px' padding='16px 0'>
                {paymentInstallmentList.map((item, index: number) => {
                    const isDisabled = isPay.includes(item.installmentNumber)
                    const isDisDelete = item.status === PaymentInstallmentListStatus.PENDING && index === (paymentInstallmentList.filter((info) => info.status === PaymentInstallmentListStatus.PAID)?.length || 0)
                    const isDisStatus = item.status === PaymentInstallmentListStatus.PAID

                    return (
                        <Grid container key={index} xs={12} alignItems='center' gap={'16px 0'}>
                            <Grid item md={1} xs={12} padding="0 8px 0px" whiteSpace={'nowrap'}>
                                {t(`TREATMENT_COURSE.FORM.PAYMENT.LNSTALLMENT_TIMES`, { index: index + 1 })}
                            </Grid>
                            <Grid item md={3} xs={6} padding="0 8px">
                                <DateInput
                                    label={t('TREATMENT_COURSE.FORM.PAYMENT.LNSTALLMENT_DATE')}
                                    onChange={(e: any) => handleChangePaymentInstallmentList(index, 'paidDate', moment(e).format('YYYY-MM-DD'))}
                                    value={item.paidDate}
                                    onClear={() => handleChangePaymentInstallmentList(index, 'paidDate', '')}
                                    disabled={isDisabled || window.location.pathname === '/approvel-list/change-cost' || props.disabled}
                                    fullWidth
                                    disabledDatePast
                                    startDate={moment(paymentInstallmentList[index - 1]?.paidDate).isBefore(moment(new Date()).format('yyyy-MM-DD')) ? moment(new Date()).format('yyyy-MM-DD') : paymentInstallmentList[index - 1]?.paidDate}
                                />
                                {/* <InputSecondNewDatePicker
                                    label={t('TREATMENT_COURSE.FORM.PAYMENT.LNSTALLMENT_DATE')}
                                    onchange={(e: any) => handleChangePaymentInstallmentList(index, 'paidDate', moment(e).format('YYYY-MM-DD'))}
                                    value={item.paidDate}
                                    allowClear={!isDisabled}
                                    onClear={() => handleChangePaymentInstallmentList(index, 'paidDate', '')}
                                    disableFuture
                                    maxDate={renderDateMaxMin(index + 1)}
                                    disablePast
                                    minDate={index === 0 ? new Date() : renderDateMaxMin(index - 1)}
                                    disabled={isDisabled}
                                /> */}
                            </Grid>
                            <Grid item md={2} xs={6} padding="0 8px">
                                <SelectInput
                                    label={t('TREATMENT_COURSE.FORM.PAYMENT.LNSTALLMENT_PER')}
                                    options={renderPercentOption(item.optionPrice)}
                                    onChange={(e) => handleChangePaymentInstallmentList(index, 'optionPrice', e.target.value)}
                                    value={item.optionPrice}
                                    disabled={isDisabled || window.location.pathname === '/approvel-list/change-cost' || props.disabled}
                                />
                            </Grid>
                            <Grid item md xs={8} padding="0 8px">
                                <Box display='flex' alignItems='center' gap='8px'>
                                    <TextInput
                                        fullWidth
                                        label={t('TREATMENT_COURSE.FORM.PAYMENT.LNSTALLMENT_AMOUNT')}
                                        onChange={(e) => {
                                            const newValue = e.target.value
                                            if (newValue === "") {
                                                handleChangePaymentInstallmentList(index, 'price', 0);
                                            } else if (/^\d+(\.\d{0,2})?$/.test(newValue)) {
                                                handleChangePaymentInstallmentList(index, 'price', newValue);
                                            }
                                        }}
                                        value={item?.price || 0}
                                        disabled={isDisabled || window.location.pathname === '/approvel-list/change-cost' || props.disabled}
                                        numberOnly
                                    />
                                    <Typography>
                                        {t('TREATMENT_COURSE.FORM.PAYMENT.BATH')}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item md={2} xs={4} padding="0 0xp 0px 8px">
                                {(index === 0 && window.location.pathname !== '/approvel-list/change-cost' && !props.disabled) &&
                                    <Typography sx={{ textDecoration: 'underline', color: colors.themeSecondColor, cursor: 'pointer' }} whiteSpace={'nowrap'} onClick={handleChangePaymentInstallmentListAverage}>
                                        {t('TREATMENT_COURSE.FORM.PAYMENT.LNSTALLMENT_NEW_AVERAGE')}
                                    </Typography>
                                }
                                {(index > 1 && window.location.pathname !== '/approvel-list/change-cost' && !props.disabled) &&
                                    <IconButton
                                        onClick={() => (!isDisDelete && !isDisStatus) && handleDeletePaymentInstallmentList(index)}
                                        sx={(isDisDelete || isDisStatus) ? {
                                            img: {
                                                filter: 'grayscale(1) invert(1)',
                                                opacity: 0.6
                                            }
                                        } :
                                            {}}
                                    >
                                        <img src={icons.btnTrash} alt="trash" />
                                    </IconButton>
                                }
                            </Grid>
                        </Grid>
                    )
                }
                )}
                <Grid container xs={12} alignItems='center'>
                    <Grid item xs={6} padding="0 8px" textAlign={'right'}>
                        {t('TREATMENT_COURSE.FORM.PAYMENT.LNSTALLMENT_TOTAL')}
                    </Grid>
                    <Grid item xs padding="0 8px">
                        <Box display='flex' alignItems='center' gap='8px'>
                            <TextInput
                                fullWidth
                                label={t('')}
                                onChange={(e) => null}
                                value={numberFormat(renderPaymentInstallmentListTotal())}
                                disabled
                            />
                            <Typography>
                                {t('TREATMENT_COURSE.FORM.PAYMENT.BATH')}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={2} padding="0 0xp 0px 8px"></Grid>
                </Grid>
            </Box>
        </Box>
    )
}

export default PaymentInstallmentBox